import React, { useState, useEffect, useMemo, useContext } from 'react';

import { getAllAreasOptions } from '@app/api/area';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import {
  CrudMasterDetailView,
  GridView,
  Widget,
  FormInput,
  FormSubmitButton,
  FormSelect,
  CompositeView,
  MasterDetailForm,
  FormatText,
  FormTextArea,
  ButtonDelete,
  CrudContext,
  useRouter,
  OptionProps,
  FormDatePicker,
  FormSwitch,
} from '@digital/ui';
import * as Yup from 'yup';

import {
  getAllDepartamento,
  createDepartamento,
  updateDepartamento,
  deleteDepartamento,
  Validacao,
} from '../../api/departamento';
import { getAllGerenteDepartamentoOptions, getAllUsuariosMRNAndTerceiroOptions } from '../../api/usuario';
import { hasPermission } from '../../helpers/permissions';

const Departamento = () => {
  const { selectedItem } = useContext(CrudContext);
  const { history } = useRouter();
  const [AllUserMrn, setGetAllMrn] = useState<OptionProps[]>();
  const [AllArea, setAllArea] = useState<OptionProps[]>();
  const [AllDiretoria, setDiretorias] = useState<OptionProps[]>();

  const [AllDepartamento, setAllDepartamento] = useState(() => {
    return getAllDepartamento;
  });

  const CarregarDados = useMemo(async () => {
    const result = await getAllUsuariosMRNAndTerceiroOptions();
    const resultArea = await getAllAreasOptions();
    const resultDiretoria = await getAllDiretoriasOptions();

    if (result) {
      setGetAllMrn(result);
    }

    if (resultArea) {
      setAllArea(resultArea);
    }

    if (resultDiretoria) {
      setDiretorias(resultDiretoria);
    }
  }, [selectedItem]);

  const onCreateDepartamento = (values: any) => {
    return createDepartamento(values).then(resp => {
      if (resp.valid) {
        setAllDepartamento(() => Promise.resolve(undefined));
        setAllDepartamento(() => getAllDepartamento);
      }
      return resp;
    });
  };

  const onUpdateDepartamento = (values: any) => {
    return updateDepartamento(values).then(resp => {
      if (resp.valid) {
        setAllDepartamento(() => Promise.resolve(undefined));
        setAllDepartamento(() => getAllDepartamento);
      }
      return resp;
    });
  };

  return (
    <CrudMasterDetailView
      getAllItems={AllDepartamento}
      createItem={hasPermission(['DEPARTAMENTO_CADASTRAR']) ? onCreateDepartamento : undefined}
      updateItem={onUpdateDepartamento}
      disableNotification
      icon="business-employee_card"
      detailTitleExtractor={item => item.sigla + ' - ' + item.nome}
      filterPredicate={(item, value) =>
        (item.nome ? item.nome.toLowerCase().includes(value.toLowerCase()) : false) ||
        (item.descricao ? item.descricao.toLowerCase().includes(value.toLowerCase()) : false) ||
        (item.sigla ? item.sigla.toLowerCase().includes(value.toLowerCase()) : false) ||
        (item.areaNome ? item.areaNome.toLowerCase().includes(value.toLowerCase()) : false) ||
        (item.nomeUsuario ? item.nomeUsuario.toLowerCase().includes(value.toLowerCase()) : false) ||
        (item.userName ? item.userName.toLowerCase().includes(value.toLowerCase()) : false) ||
        (item.enabled === true ? 'ativo' : 'inativo').includes(value.toLowerCase())
      }
      titleExtractor={item => item.sigla + ' - ' + item.nome}
      descriptionExtractor={item =>
        `${item.areaNome || '---'} - ${item.userName || '---'} - ${item.enabled === true ? 'Ativo' : 'Inativo'}`
      }>
      <CompositeView>
        {hasPermission(['Dono', 'DEPARTAMENTO_VISUALIZAR_MENU']) && (
          <CrudContext.Consumer>
            {({ selectedItem }) => {
              return (
                <GridView noform>
                  <MasterDetailForm
                    validationSchema={Yup.object().shape({
                      nome: Yup.string()
                        .required('Nome deve ser informado')
                        .max(150, 'O nome deve ter no máximo 150 caracteres.'),
                      sigla: Yup.string()
                        .required('Sigla deve ser informada')
                        .max(5, 'A sigla deve ter no máximo 5 caracteres.'),
                      descricao: Yup.string().max(2000, 'A descrição deve ter no máximo 2000 caracteres.'),
                    })}>
                    <Widget
                      title="Dados de Departamento"
                      actions={[
                        selectedItem && hasPermission(['DEPARTAMENTO_DELETAR']) && (
                          <ButtonDelete
                            icon={null}
                            type="danger"
                            confirm="Deseja realmente excluir este registro?"
                            okText="Confirmar"
                            onClick={() => {
                              deleteDepartamento(selectedItem.id).then(resp => {
                                const validacao = resp as Validacao;
                                if (validacao.valid) {
                                  setAllDepartamento(() => Promise.resolve(undefined));
                                  setAllDepartamento(() => getAllDepartamento);
                                  history.push('/departamentos');
                                }
                                return resp;
                              });
                            }}
                          />
                        ),
                        hasPermission(['DEPARTAMENTO_EDITAR', 'DEPARTAMENTO_CADASTRAR']) && (
                          <FormSubmitButton noIcon type="primary">
                            <FormatText id="ui.commons.save" uppercase />
                          </FormSubmitButton>
                        ),
                      ]}>
                      <FormInput label="Nome" name="nome" span={4} />
                      <FormInput label="Sigla" name="sigla" span={2} />
                      <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input: any, item: any) => {
                          return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                        }}
                        label="Responsável"
                        allowClear
                        name="usuarioResponsavelId"
                        placeholder="Selecione uma opção"
                        options={AllUserMrn}
                        required
                        span={6}
                      />
                      <FormSelect
                        label="Diretoria"
                        name="diretoriaId"
                        placeholder="Selecione uma opção"
                        options={AllDiretoria}
                        span={6}
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input: any, item: any) => {
                          return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                        }}
                      />
                      <FormSelect
                        label="Área"
                        name="areaId"
                        placeholder="Selecione uma opção"
                        options={AllArea}
                        span={6}
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input: any, item: any) => {
                          return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                        }}
                      />
                      {/* <FormTextArea label="Descrição" name="descricao" span={6} /> */}
                      <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input: any, item: any) => {
                          return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                        }}
                        label="Responsável Substituto"
                        name="usuarioSubstitutoId"
                        allowClear
                        placeholder="Selecione uma opção"
                        getOptions={getAllGerenteDepartamentoOptions}
                        span={6}
                      />
                      <FormDatePicker format="DD/MM/YYYY" label="Data Inicial" name="dataInicial" span={3} />
                      <FormDatePicker format="DD/MM/YYYY" label="Data Final" name="dataFinal" span={3} />
                      {selectedItem && (
                        <FormSwitch
                          label={selectedItem.enabled === true ? 'Departamento ativo' : 'Departamento inativo'}
                          name="enabled"
                          mapValues={[true, false]}
                          span={3}
                          disabled={!hasPermission(['DEPARTAMENTO_EDITAR'])}
                        />
                      )}
                    </Widget>
                  </MasterDetailForm>
                </GridView>
              );
            }}
          </CrudContext.Consumer>
        )}
      </CompositeView>
    </CrudMasterDetailView>
  );
};

export default Departamento;
